import { Button } from '@com/_atoms/NewButton';
import ActionBar from '@com/Layout/ActionBar';
import { Bottomsheet } from '@com/modal/containers/Bottomsheet';
import { colorPallete } from '@configs/color-pallete';
import useModal from '@hooks/useModal';
import Icon from '@utilities/icon';
import Link from 'next/link';

type OfficeContactBottomSheetProps = {
  officeName: string;
  phoneNumber: string;
  doctorName: string;
};

const OfficeContactBottomSheet = ({
  officeName,
  phoneNumber,
  doctorName,
}: OfficeContactBottomSheetProps) => {
  const { removeLastModal } = useModal();

  const handleConfirmNotice = () => {
    removeLastModal();
  };

  return (
    <Bottomsheet height={200} title="اطلاعات تماس" hasCloseButton>
      <div className="flex flex-col px-4 py-3 gap-y-4">
        <div className="flex items-center gap-x-3">
          <div className="h-8 w-8 rounded-lg flex items-center justify-center bg-surface-accentLight">
            <Icon
              name="HomeHealth"
              width={1.5}
              height={1.5}
              fill={colorPallete.content.accent}
            />
          </div>
          <span className="text-Label/Small text-content-secondary flex items-center gap-x-1">
            {officeName}
            <span className="text-content-tertiary">{`(${doctorName})`}</span>
          </span>
        </div>

        <div className="flex items-center justify-between">
          <span className="text-Label/Small text-content-secondary">
            شماره تماس:
          </span>

          {phoneNumber ? (
            <Link href={`tel:${phoneNumber}`}>
              <div className="flex items-center gap-x-1">
                <span className="text-Label/Small text-content-secondary">
                  {phoneNumber}
                </span>

                <div>
                  <Icon
                    name="CallRigh"
                    width={1.5}
                    height={1.5}
                    fill={colorPallete.content.accent}
                  />
                </div>
              </div>
            </Link>
          ) : (
            <span className="text-content-tertiary text-Body/Small">
              تعریف نشده
            </span>
          )}
        </div>
      </div>

      <ActionBar type="singleAction" hasDivider>
        <Button
          className="w-full"
          variant="primary"
          size="large"
          onClick={handleConfirmNotice}
        >
          متوجه شدم
        </Button>
      </ActionBar>
    </Bottomsheet>
  );
};

export default OfficeContactBottomSheet;
